import { useEffect } from "react";
import { useFetchData as useDeleteData } from "../../../hooks/useFetch/delete";
import ActionButtonByRole from "../../masterComponents/componentsByRole/actionButton";
import { ContainerWrapper } from "../../../app/app.style";
import { App } from "antd";
import ExportLogsBtn from "./settingsButtons/exportLogsBtn";

const Settings = () => {

    const { message: messageApi } = App.useApp();

    const [fetchClearCache, {
        isLoading: isLoadingClearCache,
        data,
        error: deleteError,
        clearError: clearCacheError
    }] = useDeleteData({
        query: "/cache/clear",
        selectData: (data) => data
    })

    useEffect(() => {
        if (deleteError) {
            messageApi.error(deleteError.message);
            clearCacheError?.();
        }
    }, [deleteError, messageApi])

    useEffect(() => {
        if (data?.message && !isLoadingClearCache) {
            messageApi.success(data.message)
        }
    }, [isLoadingClearCache, messageApi])

    return (
        <ContainerWrapper>
            <ActionButtonByRole fetchClearCache={fetchClearCache} />
            <ExportLogsBtn />
        </ContainerWrapper>
    )
}

export default Settings;